import { render, staticRenderFns } from "./ProductsCompensationPreselected.vue?vue&type=template&id=bf28bc98&"
import script from "./ProductsCompensationPreselected.vue?vue&type=script&lang=js&"
export * from "./ProductsCompensationPreselected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports